export default __webpack_public_path__ + "static/media/(42).d33ce4e1.jpg";